<template>
    <div>
        <!-- 导航栏 -->
        <van-nav-bar
                title="个人信息"
                left-arrow
                @click-left="onClickLeft"
        />
        <div style="display: flex;align-items:center;flex-direction: column;margin: 10px">
            <img :src="user.headImgUrl" style="width:60px;border-radius: 50px">
            <div>{{user.nickname}}</div>
        </div>
        <van-form validate-first>
            <van-field label="姓名" :value="user.name" readonly />
            <van-field label="联系方式" :value="user.phone" readonly />
            <van-field label="性别" :value="user.sex" readonly />
            <van-field label="注册时间" :value="user.createDate" readonly />
            <van-field label="类型" :value="userTypes[user.type]" readonly />

            <van-field name="radio" label="用户类型">
                <template #input>
                    <van-radio-group v-if="$store.state.user.type === userTypes.admin"
                                     v-model="userType"
                                     direction="horizontal"
                                     @change="toggleUserType"
                    >
                        <van-radio :name="userTypes.lawyer">{{userTypes[userTypes.lawyer]}}</van-radio>
                        <van-radio :name="userTypes.customer">{{userTypes[userTypes.customer]}}</van-radio>
                    </van-radio-group>
                </template>
            </van-field>

        </van-form>
    </div>
</template>

<script>
  import {responseCodes, userTypes} from '../common/const'
  import axios from '../common/axios'
  import {Toast} from 'vant'

  export default {
    name: "User",
    data() {
        return{
          user:{},
          userType:userTypes.lawyer,
          userTypes,
        }
    },
    mounted(){
      this.loadUserInfo();
    },
    methods:{
      async loadUserInfo(){
        this.$store.commit("showOverlay");
        try {
          let response = await axios.get(`/fyserve/user/getUser?openid=${this.$route.params.openId}`)
          let data = response.data;
          if (data.code === responseCodes.success) {
            this.user = data.data;
            this.userType = this.user.type;
          }else{
            Toast.fail(data.message);
          }
        }catch (e) {
          console.error(e)
          Toast.fail("加载数据失败")
        }finally {
          this.$store.commit("hideOverlay")
          this.title = '';
          this.content = ''
        }
      },
      onClickLeft() {
        this.$router.back();
      },
      async toggleUserType(){
        this.$store.commit("showOverlay");
        try {
          let response = await axios.get(`/fyserve/user/setAttorney?state=${this.userType}&openid=${this.user.openId}`)
          let data = response.data;
          if (data.code !== responseCodes.success) {
            Toast.fail(data.message);
          }
        }catch (e) {
          console.error(e)
          Toast.fail("加载数据失败")
        }finally {
          this.$store.commit("hideOverlay")
          this.title = '';
          this.content = ''
        }
      }
    }
  }
</script>

<style scoped>

</style>